module.exports = __webpack_public_path__ + "02_long_gold.f3271315.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer5/02_long_gold.png
// module id = NJkw
// module chunks = 0